'use client'

import cx from 'classnames'
import { FC } from 'react'
import { useInView } from 'react-intersection-observer'

import '@/components/Page/Page/Journal/Number/Number.scss'

type ItemProps = {
  number: string
}
const Number: FC<ItemProps> = ({ number }) => {
  const { inView, ref } = useInView({
    threshold: 0,
    rootMargin: '0px 0px -20% 0px',
    triggerOnce: true,
  })

  return (
    <p
      className={cx('c-page-journal-card-num u-font-gb', {
        'c-page-journal-card-num--inView': inView,
      })}
      ref={ref}
    >
      {Array.from(number).map((char, index) => {
        return (
          <span className="char" key={index}>
            {char}
          </span>
        )
      })}
      <span className="char char--third dot">.</span>
    </p>
  )
}

export default Number
